import { ElementRef } from '@angular/core';
export class FileInputUtil {
    public static clearFileSelection(filesField: ElementRef<HTMLInputElement>): void {
        const dt = new DataTransfer();
        filesField.nativeElement.files = dt.files;
    }
}
